import { Box, Container, Grid, Typography, Link as MuiLink, Divider, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import cfpMark from '../img/cfplogo2.svg'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import InsightsIcon from '@mui/icons-material/Insights'
import { buildCoreUrl, loginpage } from '../common/common'
import { COLOR_PRIMARY, NAVBAR_BG } from '../theme'

const columns = [
    {
        title: 'Products',
        links: [
            { label: 'Core - Tender Alerting', to: '/products/core', icon: <NotificationsActiveIcon sx={{ fontSize: 14 }} /> },
            { label: 'Tender Ninja - Safe AI Bid Writing', to: '/products/tender-ninja', icon: <AutoAwesomeIcon sx={{ fontSize: 14 }} /> },
            { label: 'Analytics - Market Intelligence', to: '/products/analytics', icon: <InsightsIcon sx={{ fontSize: 14 }} /> },
        ],
    },
    {
        title: 'Platform',
        links: [
            { label: 'Live Tenders', to: '/tenderresults' },
            { label: 'Pricing', to: '/pricing' },
            { label: 'Login', to: loginpage, external: true, core: true },
        ],
    },
    {
        title: 'Company',
        links: [
            { label: 'Contact Us', to: '/contactus' },
            { label: 'Privacy Policy', to: '/privacy' },
            { label: 'Cookie Policy', to: '/cookies' },
            { label: 'Terms & Conditions', to: '/terms' },
        ],
    },
]

export default function Footer() {
    return (
        <Box component="footer" sx={{ backgroundColor: NAVBAR_BG, color: 'white', pt: 8, pb: 4 }}>
            <Container maxWidth="lg">
                <Grid container spacing={6}>
                    {/* Brand column */}
                    <Grid item xs={12} md={3}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
                            <Box component="img" src={cfpMark} alt="" sx={{ height: 80, width: 'auto', flexShrink: 0 }} />
                            {/* <Typography sx={{ fontWeight: 700, fontSize: '15px', color: 'white' }}>
                                Contract Finder Pro
                            </Typography> */}
                        </Box>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, mb: 2 }}>
                            The UK & Ireland tender advisory and research service. Discover contract opportunities perfect for your business
                        </Typography>
                        <Typography variant="caption" sx={{ color: COLOR_PRIMARY, display: 'block', mb: 1.5 }}>
                            0333 772 0250
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)', display: 'block' }}>
                            Covering UK & Ireland Public Sector
                        </Typography>
                    </Grid>

                    {/* Cyber Essentials badge column */}
                    <Grid item xs={6} sm={4} md={9 / (columns.length + 1)}>
                        <Box sx={{
                            backgroundColor: 'white',
                            borderRadius: 2,
                            px: 1.5,
                            py: 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}>
                            <Box
                                component="img"
                                src="/cyber-essentials.png"
                                alt="Cyber Essentials certified"
                                sx={{ height: 50, width: 'auto' }}
                            />
                        </Box>
                    </Grid>

                    {/* Link columns */}
                    {columns.map(col => (
                        <Grid item xs={6} sm={4} md={9 / (columns.length + 1)} key={col.title}>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'rgba(255,255,255,0.45)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    fontWeight: 600,
                                    display: 'block',
                                    mb: 2,
                                }}
                            >
                                {col.title}
                            </Typography>
                            <Stack spacing={1.25}>
                                {col.links.map(link => {
                                    const isAbsoluteUrl = /^https?:\/\//i.test(link.to)
                                    const externalHref = 'core' in link && link.core && !isAbsoluteUrl
                                        ? buildCoreUrl(link.to)
                                        : link.to

                                    return (
                                        <MuiLink
                                            key={link.label}
                                            {...('external' in link && link.external
                                                ? { href: externalHref, target: '_blank', rel: 'noopener noreferrer' }
                                                : { component: Link, to: link.to }
                                            )}
                                            sx={{
                                                color: 'rgba(255,255,255,0.65)',
                                                textDecoration: 'none',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.75,
                                                '&:hover': { color: COLOR_PRIMARY },
                                                transition: 'color 0.15s',
                                            }}
                                        >
                                            {'icon' in link && link.icon}
                                            {link.label}
                                        </MuiLink>
                                    )
                                })}
                            </Stack>
                        </Grid>
                    ))}
                </Grid>

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', my: 5 }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)' }}>
                        © {new Date().getFullYear()} J4L Group Ltd. All rights reserved.
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)' }}>
                        Registered in England & Wales
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}
